/**
 * Created by Ning Jiang on 10/18/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";
import {CCTwoInitialWPEvents} from "../../winpresentation/initial/CreepyCarnivalTwoInitialWPController";

export class CCTwoStarSpinIntroEvents {
    public static readonly ENTER_IN_STAR_SPIN:string = "CCTwoFreeSpinEntryEvents_ENTER_IN_STAR_SPIN";
    public static readonly EXIT_FROM_STAR_SPIN:string = "CCTwoFreeSpinEntryEvents_EXIT_FROM_STAR_SPIN";
}

export class StarSpinIntroController extends ScreenController {

    private _isRestore:boolean;
    private _slotApi:any;
    private _aveBetValue:number;

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super("starspinIntro", config, tweakEnabled);
        this._slotApi = SlotGame.api;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.CHANGE_BET_FOR_STAR_SPIN, (event:GameEvent) => this.changeBetForStarSpin(event.params[0].newBet));
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === "STAR_SPIN";
    }

    protected changeBetForStarSpin(data:number):void {
        this._aveBetValue = data;
    }

    protected parseFeatureGameData(data:CreepyCarnivalTwoParsedGameData):void {
        this._isRestore = data.isRestoreState;
        let collectionData = data.getSpecialSymbolsArray,
            collectedSymbols:string[] = [];

        for(let i:number = 0; i < collectionData.length; i++) {
            collectedSymbols.push(collectionData[i].symbol);
        }

        for(let i:number = 0; i < CreepyCarnivalTwoGameConfig.instance.REEL_SETS.STAR_SPIN_REELSET.length; i++) {
            CreepyCarnivalTwoGameConfig.instance.REEL_SETS.STAR_SPIN_REELSET[i] = collectedSymbols;
        }
    }

    protected onCloseComplete():void {
        EventHandler.dispatchEvent(new GameEvent("SWITCH_TO_STAR_REELS"));
        EventHandler.dispatchEvent(new GameEvent(CCTwoStarSpinIntroEvents.ENTER_IN_STAR_SPIN));

        super.onCloseComplete();
    }
}